module.exports = __webpack_public_path__ + "static/media/icon_restoration_pontic_3.f1237db9.svg";